import adminRequest from '@/utils/h5-admin-request'

const PREFIX = '/signstore/h5admin/redbook'

export function fetchRedbookActivities(params) {
  return adminRequest.get(PREFIX + '/activities', { params })
}

export function fetchRedbookActivityDetail(id) {
  return adminRequest.get(PREFIX + '/activities/' + id)
}

export function saveRedbookActivity(data) {
  return adminRequest.post(PREFIX + '/activities', data)
}

export function deleteRedbookActivity(id) {
  return adminRequest.delete(PREFIX + '/activities/' + id)
}

export function fetchRedbookStores(params) {
  return adminRequest.get(PREFIX + '/stores', { params })
}

export function createRedbookNfc(activityId, params) {
  return adminRequest.post(PREFIX + '/activities/' + activityId + '/nfc', null, { params })
}

export function updateRedbookNfc(activityId, nfcCode, params) {
  return adminRequest.post(
    PREFIX + '/activities/' + activityId + '/nfc/' + encodeURIComponent(nfcCode) + '/update',
    null,
    { params }
  )
}

export function regenerateRedbookNfcUrl(activityId, nfcCode) {
  return adminRequest.post(PREFIX + '/activities/' + activityId + '/nfc/' + encodeURIComponent(nfcCode) + '/regenerate')
}

export function fetchRedbookPublishRecords(params) {
  return adminRequest.get(PREFIX + '/publish-records', { params })
}

export function fetchRedbookPlatformStatus() {
  return adminRequest.get(PREFIX + '/platform/status')
}

export function setRedbookNfcStatus(activityId, nfcCode, params) {
  return adminRequest.post(
    PREFIX + '/activities/' + activityId + '/nfc/' + encodeURIComponent(nfcCode) + '/status',
    null,
    { params }
  )
}

export function uploadH5AdminImage(file) {
  const data = new FormData()
  data.append('file', file)
  return adminRequest.post('/signstore/h5admin/upload/image', data, {
    timeout: 60000
  })
}
